import style from "./ColorPicker.module.scss"
import reactCSS from "reactcss"

import React, { useState } from "react"
import { GithubPicker } from "react-color"

import { useLayerPopupContext } from "@shared/contexts"

interface Props {
  changeColor: Function
}

function ColorPicker({ changeColor }: Props) {
  const { managerFont } = useLayerPopupContext()

  const [setting, setSetting] = useState({
    displayColorPicker: false,
    color: managerFont.color,
  })

  const handleClick = () => {
    setSetting({ ...setting, displayColorPicker: !setting.displayColorPicker })
  }

  const handleChange = (color: any) => {
    setSetting({ ...setting, color: color.hex, displayColorPicker: false })
    changeColor(color.hex)
  }

  const styles = reactCSS({
    default: {
      color: {
        width: "24px",
        height: "21px",
        borderRadius: "2px",
        background: setting.color,
      },
      swatch: {
        background: "#fff",
        borderRadius: "2px",
        display: "inline-block",
        cursor: "pointer",
      },
      popover: {
        position: "absolute",
        zIndex: "2",
      },
      cover: {
        position: "fixed",
        top: "0px",
        right: "0px",
        bottom: "0px",
        left: "0px",
      },
    },
  })

  return (
    <>
      <div style={styles.swatch} onClick={handleClick}>
        <div style={styles.color} />
      </div>
      {setting.displayColorPicker ? (
        <div className={style.colorPickerBox}>
          <GithubPicker
            width={"130px"}
            colors={[
              "#B80000",
              "#DB3E00",
              "#FCCB00",
              "#008B02",
              "#006B76",
              "#1273DE",
              "#004DCF",
              "#5300EB",
              "#EB9694",
              "#FAD0C3",
              "#FEF3BD",
              "#C1E1C5",
              "#BEDADC",
              "#C4DEF6",
              "#BED3F3",
              "#000000",
            ]}
            triangle={"hide"}
            color={setting.color}
            onChange={handleChange}
            className={`${style.githubPicker}`}
          />
        </div>
      ) : null}
    </>
  )
}

export default ColorPicker
